import {connect} from "react-redux";
import JourneyTravelled from "./journeyTravelled";
import {bindActionCreators} from "redux";
import {getJourneyTravelled, getJourneyTravelledByFilter} from "../../service/Journey/action";

const mapStateToProps = (state) => ({
    journeyTravelled: state.Journey.journeyTravelled,
    filter: state.Journey.journeyTravelledByFilter,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            getJourneyTravelled,
            getJourneyTravelledByFilter
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(JourneyTravelled);
